import httpUtil from "@/utils/httpUtil";

/***仓库统计 */
export const myWarehouse = params => httpUtil.get("/crk/app/myWarehouse", params);

// 出入库统计
export const getCrkStastics = params => httpUtil.get("/crk/app/getCrkStastics", params);

//出入库折线图
export const selectCrkLine = params => httpUtil.get("/crk/app/selectCrkLine", params);

//下载App
export const crkVersion = params => httpUtil.post("/app/cur/version", params);

//仓库列表
export const warehouseList = params => httpUtil.get("/crk/app/warehouseList", params);

//库房详情
export const warehouseDetail = params => httpUtil.get("/crk/app/warehouseDetail", params);

//出入库记录
export const crkBatchPage = params => httpUtil.get("/crk/app/crkBatchPage", params);

//出入库详情
export const warehouseLog = params => httpUtil.get("/crk/app/warehouseLog", params);

//关联记录批次列表
export const bindLog = params => httpUtil.get("/crk/app/crkBindPage", params);
//获取关联箱子信息
export const crkBindBoxList = params => httpUtil.get("/crk/app/crkBindBoxList", params);

export const crkTableCount = params => httpUtil.get("/crk/order/getTableCount", params);
export const getOrderInfo = params => httpUtil.get("/crk/order/orderInfo", params);

export const changeDealer = params => httpUtil.post("/crk/order/changeDealer", params);

export const crkDealerTj = params => httpUtil.get("/crk/app/getDealerTj", params);

export const getDealerList = params => httpUtil.get("/dealer/getDealer", params);

export const exportDlTj = params => httpUtil.get("/crk/app/exportDlTj", params);
export const dlTjDetail = params => httpUtil.get("/crk/app/dlTjDetail", params);
export const classDetail = params => httpUtil.get("/crk/app/dlWarehouseClassDetail", params);
export const dlFleeingTj = params => httpUtil.get("/crk/app/dlFleeingTj", params);
export const dlFleeingDetail = params => httpUtil.get("/crk/app/getFleeingDetail", params);
export const exportFleeing = params => httpUtil.get("/crk/app/exportDlFleeing", params);
export const dealerOutLog = params => httpUtil.get("/crk/app/dealerOutLog", params);
export const outLogDetail = params => httpUtil.get("/crk/app/outLogDetail", params);
export const exportOutLog = params => httpUtil.get("/crk/app/exportOutLog", params);
export const dealerDetailLog = params => httpUtil.get("/crk/app/dealerLog", params);
export const exportDealerLog = params => httpUtil.get("/crk/app/exportDealerLog", params);
export const getAllDealer = params => httpUtil.get("/crk/app/getAllDealer", params);
export const auditDealer = params => httpUtil.post("/dealer/auditDealer", params);
export const dealerLogTj = params => httpUtil.get("/crk/app/dealerLogTj", params);
export const exportDealerTjLog = params => httpUtil.get("/crk/app/exportDealerTjLog", params);
export const exportDealerStock = params => httpUtil.get("/crk/app/exportDealerStock", params);
export const dealerStockDetail = params => httpUtil.get("/crk/app/dealerStockDetail", params);